import './faq.scss';
import { findAll, onBlockRender, once } from '../../global/utils/acf-preview';

// FAQ accordion: toggle each panel's height and rotate its chevron. Panels can
// be opened independently.
function initFaq( root: ParentNode ): void {
	findAll<HTMLButtonElement>( root, '.faq__trigger' ).forEach( ( btn ) => {
		const item = btn.closest<HTMLElement>( '.faq__item' );
		const panel = item?.querySelector<HTMLElement>( '.faq__panel' );
		if ( ! item || ! panel || ! once( btn, 'Faq' ) ) {
			return;
		}

		btn.addEventListener( 'click', () => {
			const isOpen = btn.getAttribute( 'aria-expanded' ) === 'true';

			if ( isOpen ) {
				// Lock the current height, then collapse on the next frame so the
				// transition has a start value to animate from.
				panel.style.maxHeight = `${ panel.scrollHeight }px`;
				requestAnimationFrame( () => {
					panel.style.maxHeight = '0px';
				} );
				btn.setAttribute( 'aria-expanded', 'false' );
				item.classList.remove( 'is-open' );
			} else {
				panel.hidden = false;
				panel.style.maxHeight = '0px';
				// Force a reflow so the browser registers the 0 start height.
				void panel.offsetHeight;
				panel.style.maxHeight = `${ panel.scrollHeight }px`;
				btn.setAttribute( 'aria-expanded', 'true' );
				item.classList.add( 'is-open' );
			}
		} );

		panel.addEventListener( 'transitionend', ( event ) => {
			if ( event.propertyName !== 'max-height' ) {
				return;
			}
			if ( btn.getAttribute( 'aria-expanded' ) === 'true' ) {
				// Let the panel grow with its content once open.
				panel.style.maxHeight = 'none';
			} else {
				panel.hidden = true;
			}
		} );
	} );
}

onBlockRender( 'faq', initFaq );
